import * as randomstring from 'randomstring'

export const generateShortID = (): string => {
    return randomstring.generate({ length: 5 })
}

export const generateUID = (): string => {
    return randomstring.generate({ length: 36 })
}
